import { data, fn } from "jquery";
import { useEffect, useState } from "react";
import { fetchApi } from "../../../helper/api";
import { IsAlert } from "../../atoms/IsAlert";
import $  from "jquery";
const DownloadSensor = (props) => {
    useEffect(() => {
        getdata()
    }, [])
    const [listDownload, setListDownload] = useState()
    const getdata = async () => {
        var req = await fetchApi("api/Record?idSensor=" + props.data.idSensor, "GET", true)
        var status = req.status
        var res = await req.json()
        if (status === 200) {
            setListDownload(res.data)
        }
        else {
            alert(res.message)
        }
    }
    const actionDownload = async (idSensor) => {
        var dataPost = {
            "idSensors": [idSensor]
        }
        var req = await fetchApi('api/Record/requestData', "POST", true, dataPost)
        var res = await req.json()
        var status = req.status
        if (status === 200) {
            IsAlert.fire({
                title: res.status,
                text: res.message,
                icon: "success",
                showCancelButton: false,
                focusConfirm: true,
                confirmButtonText: 'OK',
                showCancelButton: false

            }).then(function (isConfirm) {
                if (isConfirm.isConfirmed) {
                    $(".close").click()
                }
            })
        }
        else{
            IsAlert.fire({
                title: res.status,
                text: res.message,
                icon: "error",
                showCancelButton: false,
                focusConfirm: true,
                confirmButtonText: 'OK',
                showCancelButton: false

            }).then(function (isConfirm) {
                if (isConfirm.isConfirmed) {
                    $(".close").click()
                }
            })
        }

    }
    if (listDownload) {
        return (
            <div
                className="modal fade"
                id="download_sensor_modal"
                tabIndex={-1}
                aria-labelledby="download_sensor_modal"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="d-flex align-items-center">
                                <h5 className="mb-0 ml-2">Download Sensor  <b>{props.data.group} {props.data.numberSensor}</b></h5>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <table className="table w-100">
                                <thead>
                                    <tr>
                                        <th>Koleksi</th>
                                        <th>Tanggal</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                            listDownload.length > 0 ?
                                                listDownload.map((e, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>
                                                                {e.collectionRecord}
                                                            </td>
                                                            <td>
                                                                {new Date(e.createdAt).toLocaleDateString()}
                                                            </td>
                                                            <td>
                                                                <a className="d-flex text-success" onClick={() => actionDownload(e.collectionRecord)}>
                                                                    <i className="las la-arrow-circle-down"></i>
                                                                    <span>Download</span>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td colSpan={3}>
                                                        <p className="text-center">Data tidak tersedia</p>
                                                    </td>
                                                </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    else{
        return <h1 className="p-4">Loading...</h1>
    }
}
export default DownloadSensor